import { render, staticRenderFns } from "./RegistryList.vue?vue&type=template&id=009062de&"
import script from "./RegistryList.vue?vue&type=script&lang=js&"
export * from "./RegistryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports